// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/spin/style/index.less
// module id = 1758
// module chunks = 0